import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FormControl } from "@angular/forms";

import { FacetFilterItemModel } from "../../../models/facet-filter-item.model";

@Component({
    selector: "[pcg-ng-categories-filter]",
    templateUrl: "./categories-filter.component.html"
})
export class CategoriesFilterComponent implements OnInit {
    public control: FormControl<Array<string>> = null;
    public options: Array<FacetFilterItemModel> = [];
    public expanded: boolean = false;

    @Input()
    public label: string = null;

    @Input("control")
    public set controlSetter(value: FormControl<Array<string>>) {
        this.control = value;
    }

    @Input("options")
    public set optionsSetter(value: Array<FacetFilterItemModel>) {
        this.options = value || [];
    }

    @Output()
    public onChange = new EventEmitter();

    public ngOnInit(): void {
        this.options.forEach(option => { option.selected = (this.control.value.indexOf(option.Id) !== -1); });
        this.expanded = this.options.some(option => option.selected);
    }

    public onExpand(): void {
        this.expanded = !this.expanded;
    }

    public onToggle(option: FacetFilterItemModel): void {
        if (option.selected) {
            if (this.control.value.indexOf(option.Id) === -1) {
                this.control.value.push(option.Id);
            }
        } else {
            this.control.value.splice(this.control.value.indexOf(option.Id), 1);
        }

        this.onChange.emit();
    }
}
